import { render } from "./AppDismissibleAlerts.vue?vue&type=template&id=83428934"
import script from "./AppDismissibleAlerts.vue?vue&type=script&lang=js"
export * from "./AppDismissibleAlerts.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__